import gql from 'graphql-tag';
import { PAGE_DETAILS_FRAGMENT, PAGE_FRAGMENT } from './fragments.graphql';

export const CREATE_PAGE = gql`
  mutation CreatePage($input: CreatePageInput!) {
    createPage(input: $input) {
      ...Page
    }
  }
  ${PAGE_FRAGMENT}
`;

export const GET_ALL_PAGES = gql`
  query GetPageList($options: PageListOptions) {
    pages(options: $options) {
      items {
        ...Page
      }
      totalItems
    }
  }
  ${PAGE_FRAGMENT}
`;

export const GET_PAGE_DETAILS = gql`
  query GetPage($id: ID!) {
    page(id: $id) {
      ...PageDetails
    }
  }
  ${PAGE_DETAILS_FRAGMENT}
`;

export const DUPLICATE_PAGE_WITH_OPTIONS = gql`
    mutation DuplicatePageWithOptions(
        $pageId: ID!
        $productId: ID
        $collectionId: ID
    ) {
        duplicatePageWithOptions(
            pageId: $pageId
            productId: $productId
            collectionId: $collectionId
        ) {
            id
            name
        }
    }
`;

export const UPDATE_PAGE = gql`
  mutation UpdatePage($input: UpdatePageInput!) {
    updatePage(input: $input) {
      ...Page
    }
  }
  ${PAGE_FRAGMENT}
`;

export const DELETE_PAGE = gql`
  mutation DeletePage($input: DeletePageInput!) {
    deletePage(input: $input) {
      result
      message
    }
  }
`;

export const IMPORT_PAGE = gql`
    mutation ImportPage($input: String!) {
        importPage(input: $input) {
            id
            name
            type
            slug
        }
    }
`;

export const EXPORT_PAGE = gql`
    mutation ExportPage($id: ID!) {
        exportPage(id: $id)
    }
`;
